/* sf-video
 * Abre el video de colocacion en una ventana adentro de la web.
 *
 * El iframe se escribe recien al abrir y se BORRA al cerrar. Dos motivos:
 *   - la ficha no carga el reproductor de YouTube en cada visita
 *   - al cerrar, el video deja de sonar. Un iframe escondido sigue reproduciendo.
 */
(function () {
  'use strict';

  var abierto = null;

  /* Cliente 2026-09-17: "cargue un video de colocacion y no funciona".
   *
   * El video SI abria y SI reproducia. Lo que estaba roto es donde se dibujaba la ventana:
   * salia metida adentro de la columna derecha en vez de cubrir la pantalla. Medido en vivo:
   * el fondo daba 630px de ancho contra 1854 de ventana, arrancando en x=997.
   *
   * La causa es `.product__info-wrapper`, que el tema marca con `scroll-trigger
   * animate--slide-in` cuando esta prendida la animacion al hacer scroll. Esa clase deja un
   * `transform` puesto, y CUALQUIER transform en un ancestro hace que `position: fixed` se
   * calcule contra ESE elemento y no contra la ventana. Da igual que el transform sea la
   * matriz identidad: con que exista alcanza.
   *
   * Por eso la ventana se muda al final del <body> al abrirse, donde no hay ningun ancestro
   * transformado. Se guarda de donde salio y se repone al cerrar, asi el editor de temas
   * sigue encontrando el bloque donde lo dejo. */
  function alBody(caja) {
    if (caja.parentElement === document.body) return;
    caja._sfVolverA = caja.parentElement;
    caja._sfVolverAntesDe = caja.nextSibling;
    document.body.appendChild(caja);
  }

  function devolver(caja) {
    var padre = caja && caja._sfVolverA;
    if (!padre) return;
    padre.insertBefore(caja, caja._sfVolverAntesDe || null);
    caja._sfVolverA = null;
    caja._sfVolverAntesDe = null;
  }

  function abrir(caja) {
    alBody(caja);
    var marco = caja.querySelector('.sf-video__marco');
    if (marco && !marco.querySelector('iframe')) {
      var f = document.createElement('iframe');
      f.setAttribute('src', marco.getAttribute('data-embed') + '?autoplay=1&rel=0');
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      f.setAttribute('allowfullscreen', '');
      f.setAttribute('title', 'Video');
      marco.appendChild(f);
    }
    caja.hidden = false;
    document.body.style.overflow = 'hidden';
    abierto = caja;
    var cerrar = caja.querySelector('[data-sf-video-cerrar]');
    if (cerrar) cerrar.focus();
  }

  function cerrar() {
    if (!abierto) return;
    var marco = abierto.querySelector('.sf-video__marco');
    if (marco) marco.innerHTML = ''; // corta el audio de verdad
    abierto.hidden = true;
    document.body.style.overflow = '';
    devolver(abierto);
    abierto = null;
  }

  function enganchar() {
    document.querySelectorAll('[data-sf-video-abrir]').forEach(function (b) {
      if (b.dataset.sfVideoListo === '1') return;
      b.dataset.sfVideoListo = '1';
      b.addEventListener('click', function () {
        var caja = document.getElementById(b.getAttribute('data-sf-video-abrir'));
        if (caja) abrir(caja);
      });
    });

    document.querySelectorAll('.sf-video__fondo').forEach(function (f) {
      if (f.dataset.sfVideoListo === '1') return;
      f.dataset.sfVideoListo = '1';
      f.addEventListener('click', function (e) {
        // Solo el fondo cierra. Un clic adentro de la caja no.
        if (e.target === f) cerrar();
      });
      var x = f.querySelector('[data-sf-video-cerrar]');
      if (x) x.addEventListener('click', cerrar);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enganchar);
  } else {
    enganchar();
  }
  document.addEventListener('shopify:section:load', enganchar);
})();
